import React, { useState } from 'react'
import TopNavbar from '../../CommonComponent/topNavbar/TopNavbar'
import Sidebar from '../../CommonComponent/sidebar/Sidebar'
import { Card, Col, Form, Row } from 'react-bootstrap';
import * as icons from 'react-bootstrap-icons';
import 'rsuite/dist/rsuite.css';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../../Footer';
import { AuctionTeamOrder } from './AuctionTeamOrder';
import { useAuctionForm } from './useAuctionForm';
import { IMAGE_ACCEPT, IMAGE_HINT } from '../../utils/helper/imageUpload';
import { FormActions } from './FormActions';
import {
  AuctionNameInput,
  BidIncrementInput,
  BidTimeSelect,
  ContestSelect,
  ManagerHoldInput,
  SecondaryMarketFields,
  SportName,
  StartDatePicker,
  StartingBidInput,
  WinnerFields,
} from './AuctionFormFields';

export const CreateAuction = () => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const form = useAuctionForm({ onSaved: () => navigate('/SuperAdmin/Auction') });

  function sidebarfun() {
    setData(!data)
  }

  const cancelbtn = (e) => {
    navigate(-1)
  }

  return (
    <>


      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group " >
        <Sidebar data={data} />
        <div className={data ? "dashboard-content full-contnet" : "dashboard-content "}>
          <Row>
            <Col md={6}><h1 className="heading-dash">Create New Auction</h1>
            </Col>
            <Col md={12}>
              <Card className='p-3 mt-3'>
                <Form noValidate validated={form.values.validated} className='manager-form' onSubmit={form.submit}>

                  <Row>
                    <Col md={4} className='text-center'>
                      <Form.Label className='mt-5'>Upload  a Logo</Form.Label>
                      <div className='group-section-auction'>
                        <Form.Label htmlFor="browse" name="auctionImage" className='image-chosse' onChange={(e) => form.uploadImage(e.target)}>
                          <icons.CameraFill className='icon-camera' />
                          <input id="browse" type="file" accept={IMAGE_ACCEPT} hidden />
                        </Form.Label>
                        {form.imageUrl ? <img src={form.imageUrl} alt="Selected" width={100} className='image-auction-create' /> : ""}
                      </div>
                      {/* #308 / #309: the one hint every image field shows, with no required mark -
                          an auction saves without a logo. */}
                      <p className='mt-2 image-upload-mess'>{IMAGE_HINT}</p>
                    </Col>
                    <Col md={6} className='border-custom'>
                      <Form.Group className="text-left">
                        <ContestSelect form={form} />
                      </Form.Group>

                      <SportName form={form} />

                      {form.values.tournamentId ?
                        <AuctionTeamOrder teams={form.values.teams} onChange={form.reorderTeams} />
                        : ""}

                      <Row>


                        <Form.Group as={Col} md={6} controlId="validationCustom02">
                          <AuctionNameInput form={form} />
                        </Form.Group>

                        <Form.Group as={Col} md={6}>
                          <StartDatePicker form={form} pickerClassName='Auction-Date' />
                        </Form.Group>
                        <Form.Group as={Col} md={6}>
                          <BidTimeSelect form={form} />
                        </Form.Group>

                        <Form.Group as={Col} md={6}>
                          <ManagerHoldInput form={form} className='select-option tournament xcuttaTakeinput' />
                        </Form.Group>

                        <Form.Group as={Col} md="6 mt-3">
                          <StartingBidInput form={form} />
                        </Form.Group>

                        <Form.Group as={Col} md="6 mt-3">
                          <BidIncrementInput form={form} />
                        </Form.Group>
                      </Row>

                      <WinnerFields form={form} />

                      <SecondaryMarketFields form={form} />
                      <FormActions onCancel={cancelbtn} disabled={form.saving || form.uploading} />
                    </Col>
                    <Col md={2}></Col>
                  </Row>
                </Form>
              </Card>
            </Col>

          </Row>

        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  )
}


